import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "grid" }

import Folder from '@components/frame/Folder.vue';

import type { IFolder } from '@typings';


export default /*@__PURE__*/_defineComponent({
  __name: 'FolderGrid',
  props: {
    items: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "item fill-block",
        key: item.fileid
      }, [
        _createVNode(Folder, { data: item }, null, 8, ["data"])
      ]))
    }), 128))
  ]))
}
}

})